import { Ban, Box, CheckCircle2, PackageCheck, ShieldAlert, UserRoundCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Checklist, CTASection, PageHero, PrototypeNotice, SectionIntro } from '../components/Sections';

export function Courier() {
  return (
    <>
      <PageHero
        eyebrow="Within-city courier"
        title="A careful handover from sender to recipient."
        text="Sawwari Courier is designed for eligible items moving within the same city, with clear responsibilities before the Captain accepts the request."
        tone="coral"
      >
        <div className="button-row">
          <Link className="button button--light" to="#courier-flow">See how it works</Link>
          <Link className="button button--ghost-light" to="/courier-prohibited-items">Review item policy</Link>
        </div>
      </PageHero>

      <section className="section" id="courier-flow">
        <div className="container">
          <SectionIntro
            eyebrow="Courier flow"
            title="Four clear responsibilities."
            text="The page is structured to teach the service before a user enters the booking flow."
            align="center"
          />
          <div className="process-grid">
            <article><span><Box /></span><small>01</small><h3>Describe the item</h3><p>Add the package type, size and required sender/recipient details.</p></article>
            <article><span><ShieldAlert /></span><small>02</small><h3>Confirm eligibility</h3><p>Review prohibited items and declare the contents accurately.</p></article>
            <article><span><PackageCheck /></span><small>03</small><h3>Seal at handover</h3><p>Prepare and seal the item in the Captain’s presence when required.</p></article>
            <article><span><UserRoundCheck /></span><small>04</small><h3>Complete delivery</h3><p>Use recipient confirmation and a traceable order record.</p></article>
          </div>
        </div>
      </section>

      <section className="section section--soft">
        <div className="container courier-rules">
          <div className="courier-rules__safe">
            <span className="icon-badge icon-badge--mint"><CheckCircle2 /></span>
            <span className="eyebrow">Before requesting</span>
            <h2>Prepare a clear, eligible package.</h2>
            <Checklist items={[
              'Use accurate sender and recipient contact details',
              'Package the item securely for normal city travel',
              'Declare contents and handling needs honestly',
              'Keep proof of the request and recipient confirmation',
            ]} />
          </div>
          <div className="courier-rules__danger">
            <span className="icon-badge icon-badge--coral"><Ban /></span>
            <span className="eyebrow">Not for courier</span>
            <h2>Unsafe or prohibited items.</h2>
            <Checklist items={[
              'Illegal, dangerous or explosive materials',
              'Weapons, contraband or undeclared valuables',
              'Items requiring specialist temperature or medical handling',
              'Any parcel the Captain cannot safely verify or carry',
            ]} />
            <Link className="text-link" to="/courier-prohibited-items">Open the policy page <span aria-hidden="true">→</span></Link>
          </div>
        </div>
        <div className="container"><PrototypeNotice>Courier remains within-city unless a different service is expressly enabled. Captains may inspect before sealing and must refuse unsafe, suspicious or prohibited items.</PrototypeNotice></div>
      </section>

      <CTASection
        title="A courier experience built around responsibility."
        text="Keep eligibility, packaging, handover and support information visible throughout the order."
        primary={{ label: 'Explore support', to: '/support' }}
        secondary={{ label: 'See city rides', to: '/services/rides' }}
      />
    </>
  );
}
